export const rateLimiterRTTI = Symbol.for("RateLimiter");
export const rateLimiterMapRTTI = Symbol.for("Map<RateLimiter>");
export const rateLimiterFactoryRTTI = Symbol.for("Factory<RateLimiter>");
export const cleanupRateLimitersRTTI = Symbol.for("cleanupRateLimiters()");
